"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class BlockDomain {
    static getAttributeTypeMap() {
        return BlockDomain.attributeTypeMap;
    }
}
BlockDomain.discriminator = undefined;
BlockDomain.attributeTypeMap = [
    {
        "name": "domain",
        "baseName": "domain",
        "type": "string"
    }
];
exports.BlockDomain = BlockDomain;
//# sourceMappingURL=blockDomain.js.map